import request from 'superagent';

interface I18nConfig {
  initialLanguage: string;
  i18nPaths: Record<string, string>;
}

declare global {
  interface Window {
    i18nConfig?: I18nConfig;
  }
}

export const loadi18nConfig = async () => {
  if (window.i18nConfig) {
    return window.i18nConfig;
  }

  try {
    const config = await getOCRemoteEntryConfigPromise();
    initializeI18nConfig(config);
    return config;
  } catch (error) {
    console.warn('Failed to load i18n configuration from endpoint, using fallback config:', error);
    // Return a fallback configuration that allows i18n to work without remote paths
    const fallbackConfig = createFallbackConfig();
    initializeI18nConfig(fallbackConfig);
    return fallbackConfig;
  }
};

export const getOCRemoteEntryConfigPromise = (): Promise<I18nConfig> => {
  return request
    .post(`/higherLogic/ui/mvc/Scripts/RemoteScripts/GetI18nConfiguration`)
    .withCredentials()
    .send()
    .then((response) => response.body)
    .then(({ i18nConfig }: { i18nConfig: I18nConfig }) => {
      return i18nConfig;
    })
    .catch((error) => {
      console.warn('i18n configuration endpoint failed:', error);
      throw error; // Re-throw to be handled by loadi18nConfig
    });
};

const createFallbackConfig = (): I18nConfig => {
  return {
    initialLanguage: 'en',
    i18nPaths: {
      // Empty paths - i18next will gracefully handle missing resources
      // and fall back to default values provided in t() calls
      en: '',
      fr: '',
      es: '',
    },
  };
};

const initializeI18nConfig = (config: I18nConfig) => {
  // Inject a script tag to set the i18n config globally
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.text = `window.i18nConfig = ${JSON.stringify(config)};`;
  document.head.appendChild(script);
};
